// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdAppGroupPermissionSetsAllPermissionSetsResult = objectOf({
  permission_sets: arrayOf(
    objectOf({
      id: string,
      permissions: arrayOf(number),
      name: string,
      number_of_assignee_developers: number,
    })
  ),
});
